import { render, staticRenderFns } from "./MarketingErrors.vue?vue&type=template&id=37c946fa&scoped=true"
import script from "./MarketingErrors.vue?vue&type=script&lang=js"
export * from "./MarketingErrors.vue?vue&type=script&lang=js"
import style0 from "./MarketingErrors.vue?vue&type=style&index=0&id=37c946fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c946fa",
  null
  
)

export default component.exports